<template>
  <svg
    width="21"
    height="18"
    viewBox="0 0 21 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1875 0.25H19.6875C20.2053 0.25 20.625 0.669727 20.625 1.1875V7.4375C20.625 7.95527 20.2053 8.375 19.6875 8.375H12.1875C11.6697 8.375 11.25 7.95527 11.25 7.4375V1.1875C11.25 0.669727 11.6697 0.25 12.1875 0.25ZM9.0625 0.25H1.5625C1.04473 0.25 0.625 0.669727 0.625 1.1875V7.4375C0.625 7.95527 1.04473 8.375 1.5625 8.375H9.0625C9.58027 8.375 10 7.95527 10 7.4375V1.1875C10 0.669727 9.58027 0.25 9.0625 0.25ZM0.625 10.5625V16.8125C0.625 17.3303 1.04473 17.75 1.5625 17.75H9.0625C9.58027 17.75 10 17.3303 10 16.8125V10.5625C10 10.0447 9.58027 9.625 9.0625 9.625H1.5625C1.04473 9.625 0.625 10.0447 0.625 10.5625ZM12.1875 17.75H19.6875C20.2053 17.75 20.625 17.3303 20.625 16.8125V10.5625C20.625 10.0447 20.2053 9.625 19.6875 9.625H12.1875C11.6697 9.625 11.25 10.0447 11.25 10.5625V16.8125C11.25 17.3303 11.6697 17.75 12.1875 17.75Z"
      fill="currentColor"
    />
  </svg>
</template>
